import colors from '../../../../../../../constants/js/colors.js';
export const constantColorBorder = {
  error: {
    base: colors.majorRed,
    hover: colors.majorRed,
    focus: colors.majorBlue
  },
  success: {
    base: colors.majorGreen,
    hover: colors.majorGreen,
    focus: colors.majorBlue
  },
  base: {
    base: '#D6D9E0B8',
    hover: colors.majorGray,
    focus: colors.majorBlue
  }
};
export const constantColorBg = {
  error: colors.minorRed10,
  success: colors.majorWhite,
  base: colors.majorWhite,
  fill: colors.blueGray40
};